export function arrayString(array = []){
	return '{' + array.toString() + '}';
}

export function emptyPromise(returnValue?){
	return Promise.resolve(returnValue);
}